/**
 * A dictionary with the common events the app can trigger.
 * @type {CommonEvents}
 * @ngesdoc constant
 * @ngname APP_EVENTS
 * @ngmodule common
 */
const appEvents = {
  start: 'app/modules/common/service/app/start',
  outdated: 'app/modules/common/service/app/outdated',
};

export default appEvents;
